import { LinearProgress as LinearProgressMui } from '@mui/material';

const LinearProgress = (props) => {
    return (
        <LinearProgressMui {...props} />
    )
}

export default LinearProgress;